import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from '../../../../shared/services/emitter.service';
import { AlertService, MessageSeverity } from '../../../../shared/services/alert.service';
import { MessageModalComponent } from '../../../../shared/components/modals/message/message-modal.component';
import { AppConstants } from '../../../../shared/constants/app.contants';
import { SMSModalComponent } from '../../../../shared/components/modals/sms/sms-modal.component';
import { SmsService } from '../../../../services/sms/sms.service';
import { Subscription } from 'rxjs';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.css']
})
export class SmsComponent implements OnInit {

  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['index', 'cellphone', 'userName', 'alert', 'active', 'action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  subscription: Subscription;

  enterprises = [];
  enterpriseSelect: number = 0;
  cellPhoneIdSelect: string = '%';
  cellPhoneSelect: string = '';

  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 0;
  length: number = 0;

  constructor(
    public dialog: MatDialog,
    private SmsService: SmsService,
    private spinner: NgxSpinnerService,
    private enterpriseService: EnterpriseService,
    private emitterService: EmitterService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.getEnterprises();

    this.subscription = this.emitterService.getMessage().subscribe(message => {
      if (message == AppConstants.EmitterService.ListSms) {
        this.getSmsList(1, '%');
      }
    });
  }



  openAddModal() {
    let dialogRef = this.dialog.open(SMSModalComponent, {
      data: {
        title: 'Registrar SMS',
        enterpriseId: this.enterpriseSelect,
        typeId: 0,
        type: AppConstants.TypeModal.REGISTER
      },
      width: '600px',
    });
  }

  openEditModal(obj) {
    let dialogRef = this.dialog.open(SMSModalComponent, {
      data: {
        title: 'Editar SMS',
        type: AppConstants.TypeModal.EDIT,
        idSelect: obj.idSmsAlert,
        typeId: 1,
        enterpriseId: this.enterpriseSelect
      },
      width: '600px',
    });
  }

  delete(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_SMS_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_SMS_CONFIRMATION_MESSAGE} ${obj.userName} ?`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSms(obj.idSmsAlert);
      }
    });
  }

  getEnterprises() {
    this.spinner.show();
    this.enterpriseService.getEnterprises().subscribe((response) => {
      this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
      this.enterpriseSelect = this.enterprises[0]["enterpriseId"];
      this.spinner.hide();
      this.cellPhoneIdSelect = this.cellPhoneSelect
      if (this.cellPhoneIdSelect == "" ||
        this.cellPhoneIdSelect == undefined) {
        this.getSmsList(1, '%');
      } else {
        this.getSmsList(1, this.cellPhoneIdSelect);
      }
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  getSmsList(page: number,search:string) {
    this.spinner.show();
    var filter = { EnterpriseId: this.enterpriseSelect, cellPhoneId: search };
    this.SmsService.getSms(filter).subscribe((response) => {
      this.dataSource.data = response;
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  changeEnterprise(data) {
    this.enterpriseSelect = data.value;
    if (this.cellPhoneIdSelect == "" ||
      this.cellPhoneIdSelect == undefined) {
      this.getSmsList(1, '%');
    } else {
      this.getSmsList(1, this.cellPhoneIdSelect);
    }
  }

  getServerData(event?: PageEvent) {
    this.cellPhoneIdSelect = this.cellPhoneSelect
    if (this.cellPhoneIdSelect == "" ||
      this.cellPhoneIdSelect == undefined) {
      this.getSmsList(event.pageIndex + 1, '%');
    } else {
      this.getSmsList(event.pageIndex + 1, this.cellPhoneIdSelect);
    }
  }

  search() {
    this.cellPhoneIdSelect = this.cellPhoneSelect
    if (this.cellPhoneIdSelect == "" ||
      this.cellPhoneIdSelect == undefined) {
      this.getSmsList(1, '%');
    } else {
      this.getSmsList(1, this.cellPhoneIdSelect);
    }
  }

  deleteSms(smsId: number) {
    this.spinner.show();
    this.SmsService.deleteSms(smsId).subscribe((response => {
      this.spinner.hide();
      this.alertService.showMessage(AppConstants.TitleModal.DELETE_SMS, AppConstants.MessageModal.DELETE, MessageSeverity.success);
      this.search();
    }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_SMS, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });
  }

}
